import {
  MdHistory,
  MdLocalShipping,
  MdCheckCircle,
  MdSchedule,
  MdErrorOutline,
  MdInfo,
} from "react-icons/md";
import { FaStar, FaRegStar } from "react-icons/fa";

export const getEmployeeTypeColor = (type) => {
  if (!type)
    return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300";
  switch (type.toLowerCase()) {
    case "full_time":
    case "full-time":
      return "bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 border border-blue-200 dark:border-blue-800";
    case "part_time":
    case "part-time":
      return "bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300 border border-green-200 dark:border-green-800";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300";
  }
};

export const getAttendanceStatusColor = (status) => {
  if (!status)
    return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300";
  switch (status.toLowerCase()) {
    case "present":
      return "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800";
    case "absent":
      return "bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300 border border-red-200 dark:border-red-800";
    case "paidleave":
    case "paid_leave":
      return "bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300 border border-amber-200 dark:border-amber-800";
    case "sickleave":
    case "sick_leave":
      return "bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300 border border-orange-200 dark:border-orange-800";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300";
  }
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return "N/A";
  const cleaned = phone.toString().replace(/\D/g, "");
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
};

// Regular gradients for normal cards (dark mode adjusted)
export const regularGradients = [
  "from-blue-50 to-indigo-100 dark:from-blue-900/30 dark:to-indigo-900/30",
  "from-emerald-50 to-teal-100 dark:from-emerald-900/30 dark:to-teal-900/30",
  "from-amber-50 to-orange-100 dark:from-amber-900/30 dark:to-orange-900/30",
  "from-rose-50 to-pink-100 dark:from-rose-900/30 dark:to-pink-900/30",
  "from-violet-50 to-purple-100 dark:from-violet-900/30 dark:to-purple-900/30",
  "from-cyan-50 to-sky-100 dark:from-cyan-900/30 dark:to-sky-900/30",
  "from-lime-50 to-green-100 dark:from-lime-900/30 dark:to-green-900/30",
  "from-fuchsia-50 to-pink-100 dark:from-fuchsia-900/30 dark:to-pink-900/30",
];

// Premium gradient for preferred/favorite card (dark mode adjusted)
export const preferredGradient =
  "from-amber-100 via-yellow-100 to-orange-100 dark:from-amber-900/50 dark:via-yellow-900/50 dark:to-orange-900/50";

// Premium border for preferred card
export const preferredBorder =
  "border-amber-300 border-2 dark:border-amber-600";

// Premium shadow for preferred card
export const preferredShadow =
  "shadow-amber-200/50 shadow-lg dark:shadow-amber-900/30";

// Regular border colors (dark mode adjusted)
export const regularBorders = [
  "border-blue-200 dark:border-blue-800",
  "border-emerald-200 dark:border-emerald-800",
  "border-amber-200 dark:border-amber-800",
  "border-rose-200 dark:border-rose-800",
  "border-violet-200 dark:border-violet-800",
  "border-cyan-200 dark:border-cyan-800",
  "border-lime-200 dark:border-lime-800",
  "border-fuchsia-200 dark:border-fuchsia-800",
];

// Premium icon background (dark mode adjusted)
export const preferredIconColor =
  "bg-amber-100 text-amber-600 dark:bg-amber-900/50 dark:text-amber-300";

// Regular icon colors (dark mode adjusted)
export const regularIconColors = [
  "bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-300",
  "bg-emerald-100 text-emerald-600 dark:bg-emerald-900/50 dark:text-emerald-300",
  "bg-amber-100 text-amber-600 dark:bg-amber-900/50 dark:text-amber-300",
  "bg-rose-100 text-rose-600 dark:bg-rose-900/50 dark:text-rose-300",
  "bg-violet-100 text-violet-600 dark:bg-violet-900/50 dark:text-violet-300",
  "bg-cyan-100 text-cyan-600 dark:bg-cyan-900/50 dark:text-cyan-300",
  "bg-lime-100 text-lime-600 dark:bg-lime-900/50 dark:text-lime-300",
  "bg-fuchsia-100 text-fuchsia-600 dark:bg-fuchsia-900/50 dark:text-fuchsia-300",
];

export const predefinedColors = [
  "Red",
  "Blue",
  "Green",
  "Black",
  "White",
  "Gray",
  "Yellow",
  "Orange",
  "Purple",
  "Pink",
  "Brown",
  "Silver",
  "Gold",
];

export const predefinedSizes = [
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "XXXL",
  "28",
  "30",
  "32",
  "34",
  "36",
  "38",
  "40",
  "Small",
  "Medium",
  "Large",
  "Extra Large",
];

export const variantTypes = [
  { id: "size", label: "Size" },
  { id: "color", label: "Color" },
  { id: "size-color", label: "Size & Color" },
  { id: "model", label: "Model" },
  { id: "custom", label: "Custom" },
];

export const fontOptions = [
  { name: "Inter", value: "Inter", class: "font-inter", category: "Modern" },
  {
    name: "Poppins",
    value: "Poppins",
    class: "font-poppins",
    category: "Elegant",
  },
  { name: "Roboto", value: "Roboto", class: "font-roboto", category: "Clean" },
  {
    name: "Open Sans",
    value: "Open Sans",
    class: "font-open-sans",
    category: "Friendly",
  },
  {
    name: "Montserrat",
    value: "Montserrat",
    class: "font-montserrat",
    category: "Bold",
  },
  {
    name: "Nunito",
    value: "Nunito",
    class: "font-nunito",
    category: "Rounded",
  },
];

export const buttonStyles = [
  { name: "Rounded", value: "rounded", class: "rounded-lg", icon: "🟢" },
  { name: "Pill", value: "pill", class: "rounded-full", icon: "🔵" },
  { name: "Square", value: "square", class: "rounded", icon: "🟣" },
];

export const layoutOptions = [
  {
    id: "fullscreen-banner",
    name: "Fullscreen Banner",
    category: "Banner Layouts",
  },
  { id: "split-screen", name: "Split Screen", category: "Banner Layouts" },
  { id: "minimal", name: "Minimal Header", category: "Simple Layouts" },
  { id: "carousel", name: "Banner Carousel", category: "Dynamic Layouts" },
  { id: "gradient", name: "Gradient Overlay", category: "Creative Layouts" },
  { id: "centered", name: "Centered Elegant", category: "Modern Layouts" },
  { id: "glass-morphism", name: "Glass Morphism", category: "Modern Layouts" },
  { id: "parallax", name: "Parallax Effect", category: "Dynamic Layouts" },
  {
    id: "product-showcase",
    name: "Product Showcase",
    category: "Product Layouts",
  },
  { id: "dark-minimal", name: "Dark Minimal", category: "Simple Layouts" },
  { id: "animated", name: "Animated Background", category: "Dynamic Layouts" },
  { id: "sidebar", name: "Sidebar Navigation", category: "Navigation Layouts" },
  { id: "card-grid", name: "Card Grid", category: "Modern Layouts" },
  { id: "masonry", name: "Masonry Grid", category: "Creative Layouts" },
  { id: "hero-sidebar", name: "Hero with Sidebar", category: "Banner Layouts" },
  { id: "split-content", name: "Split Content", category: "Content Layouts" },
  {
    id: "floating-elements",
    name: "Floating Elements",
    category: "Creative Layouts",
  },
  { id: "timeline", name: "Timeline Story", category: "Story Layouts" },
  {
    id: "testimonial",
    name: "Testimonial Focus",
    category: "Social Proof Layouts",
  },
];

export const allPredefinedThemes = [
  {
    name: "Modern Blue",
    primaryColor: "#2563eb",
    secondaryColor: "#3b82f6",
    buttonColor: "#2563eb",
    backgroundColor: "#ffffff",
    textColor: "#1f2937",
    headingColor: "#111827",
    fontFamily: "Inter",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 5,
  },
  {
    name: "Elegant Purple",
    primaryColor: "#7c3aed",
    secondaryColor: "#8b5cf6",
    buttonColor: "#7c3aed",
    backgroundColor: "#faf5ff",
    textColor: "#4c1d95",
    headingColor: "#581c87",
    fontFamily: "Poppins",
    buttonStyle: "pill",
    cardStyle: "glass",
    popularity: 5,
  },
  {
    name: "Nature Green",
    primaryColor: "#059669",
    secondaryColor: "#10b981",
    buttonColor: "#059669",
    backgroundColor: "#f0fdf4",
    textColor: "#064e3b",
    headingColor: "#065f46",
    fontFamily: "Nunito",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 4,
  },
  {
    name: "Warm Orange",
    primaryColor: "#ea580c",
    secondaryColor: "#f97316",
    buttonColor: "#ea580c",
    backgroundColor: "#fff7ed",
    textColor: "#7c2d12",
    headingColor: "#9a3412",
    fontFamily: "Roboto",
    buttonStyle: "square",
    cardStyle: "border",
    popularity: 4,
  },
  {
    name: "Dark Mode",
    primaryColor: "#60a5fa",
    secondaryColor: "#93c5fd",
    buttonColor: "#3b82f6",
    backgroundColor: "#1f2937",
    textColor: "#f3f4f6",
    headingColor: "#f9fafb",
    fontFamily: "Montserrat",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 5,
  },
  {
    name: "Ocean Blue",
    primaryColor: "#0ea5e9",
    secondaryColor: "#38bdf8",
    buttonColor: "#0284c7",
    backgroundColor: "#f0f9ff",
    textColor: "#0c4a6e",
    headingColor: "#0369a1",
    fontFamily: "Inter",
    buttonStyle: "rounded",
    cardStyle: "glass",
    popularity: 4,
  },
  {
    name: "Rose Gold",
    primaryColor: "#e11d48",
    secondaryColor: "#fb7185",
    buttonColor: "#be123c",
    backgroundColor: "#fff1f2",
    textColor: "#881337",
    headingColor: "#9f1239",
    fontFamily: "Poppins",
    buttonStyle: "pill",
    cardStyle: "glass",
    popularity: 5,
  },
  {
    name: "Sky Blue",
    primaryColor: "#0ea5e9",
    secondaryColor: "#38bdf8",
    buttonColor: "#0284c7",
    backgroundColor: "#f0f9ff",
    textColor: "#0c4a6e",
    headingColor: "#0369a1",
    fontFamily: "Inter",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 4,
  },
  {
    name: "Emerald",
    primaryColor: "#10b981",
    secondaryColor: "#34d399",
    buttonColor: "#059669",
    backgroundColor: "#ecfdf5",
    textColor: "#047857",
    headingColor: "#065f46",
    fontFamily: "Nunito",
    buttonStyle: "pill",
    cardStyle: "border",
    popularity: 3,
  },
  {
    name: "Amber",
    primaryColor: "#f59e0b",
    secondaryColor: "#fbbf24",
    buttonColor: "#d97706",
    backgroundColor: "#fffbeb",
    textColor: "#92400e",
    headingColor: "#78350f",
    fontFamily: "Roboto",
    buttonStyle: "rounded",
    cardStyle: "border",
    popularity: 3,
  },
  {
    name: "Indigo",
    themeName: "Indigo",
    themeId: "indigo",
    primaryColor: "#4f46e5",
    secondaryColor: "#818cf8",
    buttonColor: "#3730a3",
    backgroundColor: "#eef2ff",
    textColor: "#312e81",
    headingColor: "#3730a3",
    fontFamily: "Inter",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 5,
  },
  {
    name: "Pantry",
    themeName: "Pantry",
    themeId: "pantry",
    themePreviewImage:
      "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&q=85",
    primaryColor: "#16a34a",
    secondaryColor: "#f59e0b",
    buttonColor: "#15803d",
    backgroundColor: "#fffbeb",
    textColor: "#14532d",
    headingColor: "#166534",
    fontFamily: "Nunito",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 5,
  },
  {
    name: "Atelier",
    themeName: "Atelier",
    themeId: "atelier",
    primaryColor: "#be185d",
    secondaryColor: "#ec4899",
    buttonColor: "#831843",
    backgroundColor: "#fff7fb",
    textColor: "#500724",
    headingColor: "#831843",
    fontFamily: "Montserrat",
    buttonStyle: "pill",
    cardStyle: "glass",
    popularity: 5,
  },
  {
    name: "Remedy",
    themeName: "Remedy",
    themeId: "remedy",
    primaryColor: "#0f766e",
    secondaryColor: "#14b8a6",
    buttonColor: "#0f766e",
    backgroundColor: "#f0fdfa",
    textColor: "#134e4a",
    headingColor: "#115e59",
    fontFamily: "Inter",
    buttonStyle: "rounded",
    cardStyle: "shadow",
    popularity: 4,
  },
  {
    name: "Forge",
    themeName: "Forge",
    themeId: "forge",
    primaryColor: "#334155",
    secondaryColor: "#f59e0b",
    buttonColor: "#1e293b",
    backgroundColor: "#f8fafc",
    textColor: "#1e293b",
    headingColor: "#0f172a",
    fontFamily: "Montserrat",
    buttonStyle: "rounded",
    cardStyle: "border",
    popularity: 4,
  },
  {
    name: "Ovenly",
    themeName: "Ovenly",
    themeId: "ovenly",
    primaryColor: "#c2410c",
    secondaryColor: "#f59e0b",
    buttonColor: "#9a3412",
    backgroundColor: "#fff7ed",
    textColor: "#7c2d12",
    headingColor: "#9a3412",
    fontFamily: "DM Sans",
    buttonStyle: "pill",
    cardStyle: "shadow",
    popularity: 5,
  },
  {
    name: "Harvest",
    themeName: "Harvest",
    themeId: "harvest",
    primaryColor: "#3f6212",
    secondaryColor: "#ca8a04",
    buttonColor: "#4d7c0f",
    backgroundColor: "#fefce8",
    textColor: "#365314",
    headingColor: "#365314",
    fontFamily: "Nunito",
    buttonStyle: "rounded",
    cardStyle: "border",
    popularity: 4,
  },
];
// Helper function to adjust color brightness
export const adjustColor = (color, amount) => {
  let usePound = false;
  if (color[0] === "#") {
    color = color.slice(1);
    usePound = true;
  }
  const num = parseInt(color, 16);
  let r = (num >> 16) + amount;
  if (r > 255) r = 255;
  else if (r < 0) r = 0;
  let b = ((num >> 8) & 0x00ff) + amount;
  if (b > 255) b = 255;
  else if (b < 0) b = 0;
  let g = (num & 0x0000ff) + amount;
  if (g > 255) g = 255;
  else if (g < 0) g = 0;
  return (
    (usePound ? "#" : "") +
    (g | (b << 8) | (r << 16)).toString(16).padStart(6, "0")
  );
};

export const ThemedCard = ({
  children,
  className = "",
  theme,
  hasBorder = true,
}) => {
  const isDark = (() => {
    const color = theme?.backgroundColor;
    if (!color) return false;
    let hex = color.replace("#", "");
    if (hex.length === 3)
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
  })();

  return (
    <div
      className={`rounded-lg ${hasBorder ? "border" : ""} ${className}`}
      style={{
        backgroundColor: isDark
          ? adjustColor(theme.backgroundColor, 15)
          : "#ffffff",
        borderColor: isDark ? "#374151" : "#e5e7eb",
        color: theme?.textColor || (isDark ? "#e5e7eb" : "#1f2937"),
        fontFamily: theme?.fontFamily || "Inter",
        borderRadius: theme?.borderRadius || "12px",
        boxShadow:
          theme?.cardStyle === "shadow"
            ? `0 1px 3px 0 ${theme?.shadowColor || "rgba(0, 0, 0, 0.1)"}, 0 1px 2px 0 rgba(0, 0, 0, 0.06)`
            : "none",
      }}
    >
      {children}
    </div>
  );
};
export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "pending":
    case "ordered":
      return "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800";
    case "confirmed":
    case "approved":
      return "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800";
    case "delayed":
      return "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 border-orange-200 dark:border-orange-800";
    case "processing":
      return "bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 border-purple-200 dark:border-purple-800";
    case "shipped":
      return "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800";
    case "delivered":
      return "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800";
    case "partially delivered":
    case "partially_delivered":
      return "bg-teal-100 dark:bg-teal-900/30 text-teal-800 dark:text-teal-300 border-teal-200 dark:border-teal-800";
    case "cancelled":
      return "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 border-red-200 dark:border-red-800";
    default:
      return "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700";
  }
};

export const getTrackingStatusColor = (status) => {
  switch (status) {
    case "delivered":
      return "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800";
    case "in_transit":
      return "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800";
    case "out_for_delivery":
      return "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 border-orange-200 dark:border-orange-800";
    case "picked_up":
      return "bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 border-purple-200 dark:border-purple-800";
    case "label_created":
      return "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800";
    case "exception":
      return "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 border-red-200 dark:border-red-800";
    default:
      return "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700";
  }
};

export const getTrackingStatusIcon = (status) => {
  switch (status) {
    case "delivered":
      return <MdCheckCircle className="text-green-600" size={18} />;
    case "in_transit":
      return <MdLocalShipping className="text-blue-600" size={18} />;
    case "out_for_delivery":
      return <MdSchedule className="text-orange-600" size={18} />;
    case "picked_up":
      return <MdHistory className="text-purple-600" size={18} />;
    case "label_created":
      return <MdInfo className="text-yellow-600" size={18} />;
    case "exception":
      return <MdErrorOutline className="text-red-600" size={18} />;
    default:
      return <MdHistory className="text-gray-600" size={18} />;
  }
};

export const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid date";
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch (error) {
    return "Invalid date";
  }
};

export const formatDateTime = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid date";
    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (error) {
    return "Invalid date";
  }
};
export const renderStars = (rating, size = "text-base") => {
  const numericRating = Number(rating) || 0;
  return (
    <div className={`flex ${size} gap-0.5`} style={{ color: "#FFD700" }}>
      {[1, 2, 3, 4, 5].map((star) =>
        star <= numericRating ? (
          <FaStar key={star} />
        ) : (
          <FaRegStar key={star} />
        ),
      )}
    </div>
  );
};
export const colorThemes = [
  { name: "Classic", bg: "#ffffff", fg: "#000000" },
  { name: "Blue", bg: "#f0f9ff", fg: "#0369a1" },
  { name: "Purple", bg: "#faf5ff", fg: "#7c3aed" },
  { name: "Green", bg: "#f0fdf4", fg: "#059669" },
  { name: "Dark", bg: "#1f2937", fg: "#ffffff" },
  { name: "Brand", bg: "#ffffff", fg: "#4f46e5" },
];

const BADGE = {
  PAGE_VIEW:
    "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300",
  CLICK: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  SCROLL: "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300",
  PRODUCT_VIEW:
    "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
  ADD_TO_CART:
    "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300",
};
export const EventBadge = ({ type }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${BADGE[type] || BADGE.SCROLL}`}
  >
    {type}
  </span>
);